import React from 'react';
import { observer } from 'mobx-react-lite';

import { ProjectContactItem } from './project-contact-item';
import { EmptyContact } from './empty-contact';
import { AddKeyContactModal } from '../../collaborators/components/add-key-contact.modal';
import { getFullName } from '../../../lib/utils/get-full-name';

import type { TeamContact } from '../../teams/models/team';
import { openModal } from '../../../core/modal/open-modal';

import styles from './project-contacts.module.scss';
type ProjectContactsProps = {
  projectId: string;

  spaceId: string;

  contacts: TeamContact[];
};

export const ProjectContacts: React.FC<ProjectContactsProps> = observer(
  ({ projectId, spaceId, contacts }) => {
    const producer = contacts.find(
      (collaborator) => collaborator.role?.toLowerCase() === 'producer',
    );
    const director = contacts.find(
      (collaborator) => collaborator.role?.toLowerCase() === 'director',
    );
    const line = contacts.find(
      (collaborator) => collaborator.role?.toLowerCase() === 'line producer',
    );

    const openKeyContactModal = (position: string) => {
      openModal(AddKeyContactModal, {
        projectId,
        spaceId,
        position,
        title: `Select ${position?.toLowerCase()}`,
      });
    };

    return (
      <div className={styles['container']}>
        {producer ? (
          <ProjectContactItem
            avatar={producer.avatar || ''}
            name={getFullName(producer)}
            position="Producer"
          />
        ) : (
          <EmptyContact contactName="Producer" onClick={() => openKeyContactModal('Producer')} />
        )}

        {director ? (
          <ProjectContactItem
            avatar={director.avatar || ''}
            name={getFullName(director)}
            position="Director"
          />
        ) : (
          <EmptyContact contactName="Director" onClick={() => openKeyContactModal('Director')} />
        )}

        {line ? (
          <ProjectContactItem
            avatar={line.avatar || ''}
            name={getFullName(line)}
            position="Line Producer"
          />
        ) : (
          <EmptyContact
            contactName="Line Producer"
            onClick={() => openKeyContactModal('Line producer')}
          />
        )}
      </div>
    );
  },
);
